module.exports = __webpack_public_path__ + "img/Differentiation-PRCA_SpatialResearch.71617b34.png";